<template>
  <b-modal id="info-modal" title="Módulo de información histórica">
    <p>
      Considere lo siguiente:
    </p>
    <ul>
      <li>
        La información historica se guarda por un máximo de 90 días.
      </li>
      <li>
        Si no hay cambios, se guarda igualmente.
      </li>
      <li>
        A veces la historia se repite. Cuando son iguales se elimina al día siguiente.
      </li>
    </ul>
  </b-modal>
</template>

<script>
export default {
  name: "InfoModal"
};
</script>

<style></style>
